
export default {
props: {
  	mask: {
      type: String,
	  default: "1"
  	},
    image: {
      type: String,
	  default: ""
  	},
    width: {
      type: String,
	  default: "100%"
  	},
	horiz: {
		type: String,
		default: "50"
	},
	vert: {
		type: String,
		default: "50"
	},
	bgsize: {
		type: String,
		default: "cover"
	},
	alt_text: {
		type: String,
		default: ""
	}
}
}
